export const EmailAlertStatusApi = Symbol.for('EmailAlertStatusApi');
